import { Route } from '@angular/router';
import { SettingPermissions } from '@backoffice/shared/bo/util-permissions';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { SettingSpotConfigurationIdentifierListComponent } from './setting-spot-configuration-identifier-list.component';

export const settingSpotConfigurationIdentifier: Route = {
  path: 'spotConfigurationIdentifier/:idSpot/:energySource/:country/:stockMarket',
  component: SettingSpotConfigurationIdentifierListComponent,
  canActivate: [ngxPermissionsGuard],
  data: {
    permissions: {
      only: SettingPermissions.settingSpot,
    },
  },
  children: [
    {
      path: 'preview/:id',
      loadComponent: () =>
        import(
          '../setting-spot-configuration-identifier-details/setting-spot-configuration-identifier-details.component'
        ).then((mod) => mod.SettingSpotConfigurationIdentifierDetailsComponent),
      canDeactivate: [CanDeactivateGuard],
    },
  ],
};
